<template>
    <div class="page container-fluid container-table">
        <particles-bg type="cobweb" :bg="true" num=200 color="#303030" />
        <div class="row vertical-center-row text-center">
            <div class="d-flex justify-content-center">
                <div class="col-sm-8 text-light">
                    <div class="block rounded py-5">
                        <div class="display-2 pb-5"><i class="fas fa-dragon text-light text-neon"></i></div>
                        <div class="h1"><p>ENSAMBLADOR GAMER</p></div>
                        <span class="display-4">
                            <router-link to="/mode"><i class="fas fa-chevron-down text-light"></i></router-link>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Assembler',
}
</script>